import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import HomepageNav from '../components/HomepageNav';
import MobileNav from '../components/MobileNav';
import Footer from '../components/Footer';
import './RechnerDetail.css';

const RechnerDetail = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);

  const rechnerInfo = {
    1: { name: 'Brutto-Netto-Rechner', description: 'Berechnen Sie schnell und einfach Ihr Nettogehalt aus dem Bruttogehalt' },
    2: { name: 'Einkommensteuertabelle', description: 'Übersichtliche Darstellung der Einkommensteuer nach Steuerstufen' },
    3: { name: 'Lohnsteuertabelle', description: 'Ermitteln Sie die Lohnsteuer für verschiedene Einkommensstufen' },
    4: { name: 'Sachbezug Dienstwohnung', description: 'Berechnung des Sachbezugswerts für eine Dienstwohnung' },
    5: { name: 'Pauschalratendarlehen-Rechner', description: 'Berechnen Sie Ihre monatlichen Raten für Ihr Darlehen' },
    6: { name: 'Anspruchsverzinsungs-Rechner', description: 'Ermittlung von Verzugszinsen und Anspruchsverzinsung' },
    7: { name: 'Gewinnfreibetragsrechner', description: 'Berechnen Sie Ihren steuerlichen Gewinnfreibetrag' },
    8: { name: 'Lohnnebenkosten-Rechner', description: 'Ermittlung der Lohnnebenkosten für Arbeitgeber' },
    9: { name: 'Lohnpfändungsrechner', description: 'Berechnung des pfändbaren Einkommens' },
    10: { name: 'Skontoberechnung', description: 'Berechnen Sie Skonto und effektive Zinssätze' }
  };

  const rechner = rechnerInfo[id];

  useEffect(() => {
    // Entferne vorheriges Script falls vorhanden
    const oldScript = document.getElementById('rechner-script');
    if (oldScript) {
      oldScript.remove();
    }

    // Entferne vorherigen Rechner-Container
    const oldContainer = document.getElementById('online-rechner');
    if (oldContainer) {
      oldContainer.innerHTML = '';
    }

    // Lade neues Script
    const script = document.createElement('script');
    script.id = 'rechner-script';
    script.type = 'text/javascript';
    script.src = `https://www.infomedia.co.at/includes/js/online-rechner.js.php?Rechner=${id}&KdNr=1698`;
    script.async = true;
    
    script.onload = () => {
      setLoading(false);
    };

    script.onerror = () => {
      setLoading(false);
    };

    document.head.appendChild(script);

    // Cleanup beim Unmount
    return () => {
      const scriptToRemove = document.getElementById('rechner-script');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [id]);

  if (!rechner) {
    return (
      <div className="rechner-detail-page">
        <HomepageNav />
        <MobileNav />
        <main className="rechner-detail-page__content">
          <div className="rechner-detail-page__error">
            <h1>Rechner nicht gefunden</h1>
            <Link to="/rechner" className="rechner-detail-page__back-btn">
              Zurück zur Übersicht
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="rechner-detail-page">
      <HomepageNav />
      <MobileNav />
      
      <main className="rechner-detail-page__content">
        <Link to="/rechner" className="rechner-detail-page__back-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Zurück zur Übersicht
        </Link>

        <div className="rechner-detail-page__header">
          <h1 className="rechner-detail-page__title">{rechner.name}</h1>
          <p className="rechner-detail-page__description">{rechner.description}</p>
        </div>

        {loading && (
          <div className="rechner-detail-page__loading">
            <div className="rechner-detail-page__spinner"></div>
            <p>Rechner wird geladen...</p>
          </div>
        )}

        <div className="rechner-detail-page__calculator">
          <div id="online-rechner"></div>
        </div>

        <div className="rechner-detail-page__disclaimer">
          <h3 className="rechner-detail-page__disclaimer-title">Hinweis</h3>
          <p className="rechner-detail-page__disclaimer-text">
            Dieser Rechner dient ausschließlich Informationszwecken. Die Ergebnisse stellen keine 
            rechtsverbindliche Auskunft dar. Für eine individuelle Beratung kontaktieren Sie uns gerne.
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RechnerDetail;

